if (!document.getElementById('shad')) {

    document.write('<div id="shad" style="display:none;">&nbsp;</div>');
}

function pushToWshopBus() {};

$(document).ready(function() {

    $("#connexion_top").hover(function() {

        $(this).children("#wrapper_infos_client").show();
    }, function() {

        if (document.activeElement != undefined) {

            if (document.activeElement.type != 'text' && document.activeElement.type != 'password') {

                $(this).children("#wrapper_infos_client").hide();
            }
        }
    });

    $('.passlost').click(function() {

        $('#connexionTopb .content').animate({ height: $('.forgotPwd').height() }, 600);

        $('.auth').fadeOut(600, function() {

            $('.forgotPwd').fadeIn(600);
        });
    });

    $('#lostpwdTopSucces2 a').click(function() {

        $('#connexionTopb .content').animate({ height: $('.auth').height() }, 600);

        $('.forgotPwd').fadeOut(600, function() {

            $('.auth').fadeIn(600);
        });
    });

    try {
        WPApi.prototype.setOption('arrowOffsetLeft', -22);
    } catch (e) {}

    $(".ui-datepicker").append("<div class='closeReservation' onclick='closeReservation('ui-datepicker-div');''><span></span></div>");
});